export default __webpack_public_path__ + "static/media/Aura-Egg__15.61f56637.png";